export const filterFromTable = (e, nameRow, list) => {
    const fullName = (el) => {
        return `${el?.lastName ? `${el?.lastName} ` : ''}${el?.firstName ? `${el?.firstName} ` : ''}${el?.middleName ? `${el?.middleName}` : ''}`.trim();
    };

    const getValueByPath = (obj, path) => {
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    };

    const inputValue = e.target.value.toString().toLowerCase();
    const terms = inputValue.split(/\s|,/).filter(Boolean); // բաժանում space կամ comma-ով

    return nameRow
        ? nameRow === "firstName"
            ? list?.filter((el) => {
                const val = el[e.target.name]?.[nameRow];
                if (!val) return false;
                const haystack = fullName(el[e.target.name]).toLowerCase();
                return terms.every((t) => haystack.includes(t));
            })
            : list?.filter((el) => {
                const nestedValue = getValueByPath(el[e.target.name], nameRow);
                if (!nestedValue) return false;
                return terms.every((t) =>
                    nestedValue.toString().toLowerCase().includes(t)
                );
            })
        : e?.target.name === "statuses"
            ? list?.filter((el) => {
                const status = el?.status?.toString().toLowerCase();
                return terms.every((t) => status?.includes(t));
            })
            : list?.filter((el) => {
                const nestedValue = getValueByPath(el, e.target.name);
                if (!nestedValue) return false;
                const haystack = nestedValue.toString().toLowerCase();
                return terms.every((t) => haystack.includes(t));
            });
};
